<template>
    <footer>

    <!-- Footer Menu (dock personalizable por usuario).
         Inicio y Salir son fijos; el centro lo arma cada usuario arrastrando
         apps desde el Home. La configuración se guarda en la BD por usuario. -->
    <div id="footer-menu" :class="footerClass"
         :style="dragOver ? 'box-shadow: inset 0 0 0 2px #009AD7;' : ''">

        <!-- Inicio (fijo) -->
        <a :href="fnInicio.url" class="active-nav4">
            <i :data-feather="fnInicio.icon" data-feather-line="1" data-feather-size="21"
               :data-feather-color="fnInicio.tone + '-dark'" :data-feather-bg="fnInicio.tone + '-fade-dark'"></i>
            <span>{{ fnInicio.name }}</span>
        </a>

        <!-- Apps personalizables (arrastrables) -->
        <a v-for="id in dock" :key="id" :href="fn(id).url" :onclick="fn(id).onclick" :data-fid="id"
           class="dock-mid" draggable="false"
           style="-webkit-user-select:none; user-select:none; -webkit-user-drag:none;">
            <i :data-feather="fn(id).icon" data-feather-line="1" data-feather-size="21"
               :data-feather-color="fn(id).tone + '-dark'" :data-feather-bg="fn(id).tone + '-fade-light'"></i>
            <span>{{ fn(id).name }}</span>
        </a>

        <!-- Salir (fijo) -->
        <a :href="fnSalir.url">
            <i :data-feather="fnSalir.icon" data-feather-line="1" data-feather-size="21"
               :data-feather-color="fnSalir.tone + '-dark'" :data-feather-bg="fnSalir.tone + '-fade-dark'"></i>
            <span>{{ fnSalir.name }}</span>
        </a>

        <div class="clear"></div>
    </div>

    </footer>
</template>


<script>

import { dockBus } from "./../dockBus.js";
import { enableDockDrag } from "./../dockdrag.js";
import {
    FN_INICIO, FN_SALIR, DEFAULT_DOCK, DOCK_MAX,
    getFunctionById, getUserFunctions, getUserDock, saveUserDock
} from "./../appfunctions.js";

export default {

    data() {
        return {
            fnInicio: FN_INICIO,
            fnSalir: FN_SALIR,
            dock: [],          // IDs de las apps del centro, en orden
            allowed: null,     // IDs permitidos (null = todas)
            cod: 0,
            dragOver: false
        };
    },

    computed: {
        // El tema tiene clases footer-menu-1..6-icons; +2 por Inicio y Salir
        footerClass() {
            return "footer-menu-" + (this.dock.length + 2) + "-icons footer-menu-style-1";
        }
    },

    methods: {
        fn(id) {
            return getFunctionById(id) || { url: "#", icon: "circle", tone: "gray2", name: "" };
        },

        isAllowed(id) {
            if (!getFunctionById(id)) return false;
            if (id === FN_INICIO.id || id === FN_SALIR.id) return false; // fijos, no van al dock
            if (!this.allowed) return true;
            return this.allowed.indexOf(id) >= 0;
        },

        // Índice destino dentro del dock según la X donde se soltó
        indexFromX(x) {
            var nodos = document.querySelectorAll("#footer-menu .dock-mid");
            for (var i = 0; i < nodos.length; i++) {
                var r = nodos[i].getBoundingClientRect();
                if (x < r.left + r.width / 2) return i;
            }
            return nodos.length;
        },

        dentroDelFooter(y) {
            var el = document.getElementById("footer-menu");
            if (!el) return false;
            var r = el.getBoundingClientRect();
            return y >= r.top - 24;
        },

        onDragMove(p) {
            this.dragOver = this.dentroDelFooter(p.y);
        },

        onDragDrop(d) {
            this.dragOver = false;
            var dentro = this.dentroDelFooter(d.y);

            if (!dentro) {
                // Soltó fuera del dock -> si venía del dock, se quita
                if (d.origin === "dock") this.quitar(d.funcId);
                return;
            }
            var idx = this.indexFromX(d.x);
            if (d.origin === "dock") this.mover(d.funcId, idx);
            else this.agregar(d.funcId, idx);
        },

        agregar(id, idx) {
            if (!this.isAllowed(id)) return;
            var d = this.dock.slice();
            var ya = d.indexOf(id);
            if (ya >= 0) {                       // ya estaba: es un re-ordenar
                d.splice(ya, 1);
                if (ya < idx) idx--;
            } else if (d.length >= DOCK_MAX) {   // dock lleno: empuja el último
                d.pop();
            }
            if (idx < 0) idx = 0;
            if (idx > d.length) idx = d.length;
            d.splice(idx, 0, id);
            this.commit(d);
        },

        mover(id, idx) {
            var d = this.dock.slice();
            var cur = d.indexOf(id);
            if (cur < 0) return;
            d.splice(cur, 1);
            if (cur < idx) idx--;
            if (idx < 0) idx = 0;
            if (idx > d.length) idx = d.length;
            d.splice(idx, 0, id);
            this.commit(d);
        },

        quitar(id) {
            var d = this.dock.filter(function (x) { return x !== id; });
            if (d.length === 0) return;          // dejar al menos una app
            this.commit(d);
        },

        commit(d) {
            this.dock = d;
            saveUserDock(this.cod, this.dock);
            this.refrescar();
        },

        // Redibuja los íconos feather, aplica tamaño y conecta el arrastre
        refrescar() {
            this.$nextTick(function () {
                var tries = 0;
                var apply = function () {
                    var jq = window.jQuery || window.$;
                    if (window.feather && jq) {
                        window.feather.replace();
                        jq(".feather").each(function () {
                            jq(this).attr("stroke-width", jq(this).data("feather-line"));
                            jq(this).attr("width", jq(this).data("feather-size"));
                            jq(this).attr("height", jq(this).data("feather-size"));
                            jq(this).css("width", jq(this).data("feather-size"));
                            jq(this).css("height", jq(this).data("feather-size"));
                        });
                    } else if (tries++ < 20) {
                        setTimeout(apply, 100);
                    }
                };
                apply();

                // Conectar arrastre a cada app del centro (las nuevas)
                var nodos = document.querySelectorAll("#footer-menu .dock-mid");
                for (var i = 0; i < nodos.length; i++) {
                    var el = nodos[i];
                    if (el._dockDragCleanup) continue;
                    enableDockDrag(el, el.getAttribute("data-fid"), "dock");
                }
            });
        }
    },

    created() {
        var user = JSON.parse(localStorage.getItem("user")) || {};
        this.cod = user.codusuario || 0;
        var self = this;

        getUserFunctions(this.cod).then(function (ids) {
            self.allowed = ids; // null = todas
            getUserDock(self.cod).then(function (dock) {
                var base = (dock && dock.length) ? dock : DEFAULT_DOCK.slice();
                // Solo apps válidas y permitidas
                var filtrado = base.filter(function (id) { return self.isAllowed(id); });
                if (filtrado.length === 0) {
                    filtrado = DEFAULT_DOCK.filter(function (id) { return self.isAllowed(id); });
                }
                self.dock = filtrado;
                self.refrescar();
            });
        });

        // Escuchar el arrastre que viene del Home o del propio dock
        dockBus.$on("drag:move", this.onDragMove);
        dockBus.$on("drag:drop", this.onDragDrop);
        dockBus.$on("drag:end", function () { self.dragOver = false; });
    },

    mounted() {
        this.refrescar();
    },

    beforeDestroy() {
        dockBus.$off("drag:move", this.onDragMove);
        dockBus.$off("drag:drop", this.onDragDrop);
    }

}

</script>
